import * as Common from '@/tenant/common';

export class StockPricing extends Common.ObjectBase{
  constructor(){
    super('StockPricing')
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
  }

  public id: number = 0;
  public summaryId: number = 0;
  public commodity: Common.Commodity = null;
  public closingDate: Date = new Date().getCalendarDate();
  public stockPrice: number = 0;
  public pricingAmount: number = 0;
  public stockAmount: number = 0;
}

export enum VoucherTypes
{
  Rollover = 1,
  Migration = 2,
  PurchaseDelivery = 11,
  PurchaseCharge = 13,
  RelocationOut = 31,
  TransferOut = 33,
  RelocationIn = 35,
  TransferIn = 37,
  SalesDelivery = 51,
  SalesCharge = 53,
  QuantityAdjustment = 71,
  InventoryFraction = 91,
  WithDrawFraction = 92,
}

export class StockPricingQuery extends Common.LoadQuery {
  constructor(){
    super('StockPricingQuery',StockPricing);
    this.sort = 'id';
  }

  public id: number = 0;
  public closingDate: Date = new Date().getCalendarDate();
}